import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import moment from "moment"

import { WhatsOnDataContext } from "../../../../../../context/WhatsOnDataContext";

import { initialDate } from "../../../../../../constants/constants";

const AdminFiltersLogic = () => {
  const { getGuide } = useContext(WhatsOnDataContext);

  const { hotel } = useParams();
  const [date, setDate] = useState(initialDate);

  const isValidDate = (selectedDate) => {
    try {
      const currentDate = new Date(initialDate);
      if (selectedDate.getTime() < currentDate.getTime()) {
        return false;
      }

      const year = selectedDate.getFullYear();
      if (isNaN(year) || year.toString().length > 4) {
        return false;
      }

      return true;
    } catch (error) {
      console.error(
        `${new Date()} Error in isValidDate func in AdminFiltersLogic.js ${
          error.message
        }`
      );
    }
  };

  const handleChange = (value) => {
    try {
      const selectedDate = new Date(value);
      const formatedDate = moment(selectedDate).format("YYYY-MM-DD")
      const isValid = isValidDate(selectedDate);

      if (!isValid) {
        setDate(moment(new Date()).format("YYYY-MM-DD"));
        return;
      }

      setDate(formatedDate);
    } catch (error) {
      console.error(
        `${new Date()} Error in handleChange func in AdminFiltersLogic.js ${
          error.message
        }`
      );
    }
  };

  const filterByDate = async (date) => {
    const params = {
      showDates: [date],
      hotel,
    };
    await getGuide(params);
  };

  useEffect(() => {
    if (date) {
      filterByDate(date);
    }
  }, [date]);

  return { handleChange, date };
};

export default AdminFiltersLogic;
